// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const StopFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path d="M70 76H26a6 6 0 0 1-6-6V26a6 6 0 0 1 6-6h44a6 6 0 0 1 6 6v44a6 6 0 0 1-6 6" fillRule="evenodd" />
	</svg>
);
export default StopFilled;
